import { Button, ButtonGroup } from "@chakra-ui/react";
import { t } from "i18next";
import { CommentCreator } from "../inputs/CommentCreator";
import { useState } from "react";

interface Props {
  osaWayId: string;
}
export const AddGeneralComment: React.FC<Props> = ({ osaWayId }) => {
  const [showCommentCreator, setShowCommentCreator] = useState(false);

  return showCommentCreator ? (
    <CommentCreator
      osaWayId={osaWayId}
      onClose={() => setShowCommentCreator(false)}
    />
  ) : (
    <ButtonGroup alignSelf="end">
      <Button
        colorPalette="primary"
        size="sm"
        onClick={() => setShowCommentCreator(true)}
      >
        {t("map:wayComments.addBtn")}
      </Button>
    </ButtonGroup>
  );
};
